import fa from "../assets/charactes/1.png";
import fi from "../assets/charactes/1.svg";
import ta from "../assets/charactes/2.png";
import ti from "../assets/charactes/2.svg";
import tha from "../assets/charactes/3.png";
import thi from "../assets/charactes/3.svg";
import foa from "../assets/charactes/4.png";
import foi from "../assets/charactes/4.svg";
import fia from "../assets/charactes/5.png";
import fii from "../assets/charactes/6.svg";
import sa from "../assets/charactes/6.png";
import si from "../assets/charactes/5.svg";
import sea from "../assets/charactes/7.png";
import sei from "../assets/charactes/7.svg";
import ea from "../assets/charactes/8.png";
import ei from "../assets/charactes/8.svg";
import na from "../assets/charactes/9.png";
import ni from "../assets/charactes/9.svg";
import tea from "../assets/charactes/10.png";
import tei from "../assets/charactes/10.svg";

export const levels = {
    1: {
        active: fa,
        inactive: fi,
        name: 'Schoolboy',
        count: 0,
        multiplicator: 1
    },
    2: {
        active: ta,
        inactive: ti,
        name: 'Student',
        count: 5,
        multiplicator: 1.2
    },
    3: {
        active: tha,
        inactive: thi,
        name: 'Bachelor',
        count: 20,
        multiplicator: 1.4
    },
    4: {
        active: foa,
        inactive: foi,
        name: 'Master',
        count: 50,
        multiplicator: 1.6
    },
    5: {
        active: fia,
        inactive: fii,
        name: 'Full doctor',
        count: 100,
        multiplicator: 2
    },
    6: {
        active: sa,
        inactive: si,
        name: 'Professor',
        count: 200,
        multiplicator: 3
    },
    7: {
        active: sea,
        inactive: sei,
        name: 'Academician',
        count: 400,
        multiplicator: 5
    },
    8: {
        active: ea,
        inactive: ei,
        name: 'Visionary',
        count: 600,
        multiplicator: 6
    },
    9: {
        active: na,
        inactive: ni,
        name: 'Mad scientist',
        count: 800,
        multiplicator: 8
    },
    10: {
        active: tea,
        inactive: tei,
        name: 'IQ MONSTER',
        count: 1000,
        multiplicator: 10
    }
}